import { useEffect } from 'react';

export const useDisableBodyScroll = () => {
  useEffect(() => {
    // Disable scrolling on the body element when the component mounts
    document.body.style.overflow = 'hidden';

    // Re-enable scrolling on the body element when the component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
};

export const useDisableBodyScrollOnTrigger = (bodyScrollIsDisabled: boolean) => {
  useEffect(() => {
    bodyScrollIsDisabled ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'auto');

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [bodyScrollIsDisabled]);
};
